export const IMAGES = {
  Profile1: require("../assets/image/1.jpeg"),
  Profile2: require("../assets/image/2.jpeg"),
  Profile3: require("../assets/image/3.jpeg"),
  Profile4: require("../assets/image/4.jpeg"),
};

